import { ColumnDef } from "@tanstack/react-table";
import { TableTypes } from "tvs-unified-lib";
import { DropdownButton } from "@/components/Dropdown/Index";
import { DataType, SelectOptionType } from "./types";
import { PortfolioText, TextTemplateName } from "./styles";
import { formatDateTime } from "@/utils/common";
import { useNavigate } from "react-router-dom";

export const templateColumns = (
  copyTemplate: (id) => void
): ColumnDef<DataType>[] => [
  {
    accessorKey: " ",
    enableSorting: false,
    size: 50,
    cell: ({ row }: TableTypes.CellType<DataType>) => {
      return (
        <DropdownButton
          id="button-3"
          buttonProps={{
            variant: "no-border",
          }}
          menus={[
            {
              label: "Copy",
              onClick: () => {
                copyTemplate(row.original.id);
              },
            },
          ]}
        />
      );
    },
  },
  {
    header: () => "Template Name",
    enableSorting: false,
    accessorKey: "name",
    size: 200,
    cell: ({ row }: TableTypes.CellType<DataType>) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const navigate = useNavigate();
      const value = row.getValue("name") as string;
      const templateId = row.original.id;

      return (
        <TextTemplateName
          onClick={() => navigate(`/templates/edit/${templateId}`)}
          style={{ cursor: "pointer", color: "#2196f3" }}
        >
          {value}
        </TextTemplateName>
      );
    },
  },
  {
    header: "Channel",
    enableSorting: false,
    accessorKey: "channel",
    size: 200,
    cell: ({ getValue }: TableTypes.CellType<DataType>) => {
      const value = getValue();
      return value;
    },
  },
  {
    header: "Portfolio",
    enableSorting: false,
    accessorKey: "campaignTemplatePortfolioCategories",
    cell: ({ getValue }: TableTypes.CellType<DataType>) => {
      const value = getValue();
      return value?.length ? (
        <PortfolioText>
          {value.map((item) => item.portfolioCategory.value).join(", ")}
        </PortfolioText>
      ) : (
        "-"
      );
    },
  },
  {
    header: "Updated By",
    enableSorting: false,
    accessorKey: "updatedUser",
    cell: ({ getValue }: TableTypes.CellType<DataType>) => {
      const value = getValue();
      return value ? value.firstName + " " + value.lastName : "-";
    },
  },
  {
    header: "Updated Date",
    enableSorting: false,
    accessorKey: "updatedAt",
    size: 150,
    cell: ({ getValue }: TableTypes.CellType<DataType>) => {
      const value = getValue();
      return formatDateTime(value);
    },
  },
  {
    header: "Created By",
    enableSorting: false,
    accessorKey: "createdUser",
    cell: ({ getValue }: TableTypes.CellType<DataType>) => {
      const value = getValue();
      return value ? value.firstName + " " + value.lastName : "-";
    },
  },
];

export const channelOptions: SelectOptionType[] = [
  { label: "All Channels", value: "" },
  { label: "SMS", value: "SMS" },
  { label: "Whatsapp", value: "Whatsapp" },
];

export const channelFormOptions: SelectOptionType[] = [
  { label: "SMS", value: "SMS" },
  { label: "Whatsapp", value: "Whatsapp" },
];

export const optionsDataSource = [
  { label: "Data Upload", value: "Data Upload" },
  { label: "AIDC", value: "AIDC" },
];
